/**
 * File: PhoneNumberField.js
 * Origin: isotect
 * Description: PhoneNumberField component for forms.
 *
 * Version: v2.0.0
 * Created: 2025-12-29
 * Last Updated: 2026-01-21
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * PhoneNumberField component renders a tel input field for use in forms.
 *
 * @component
 *
 * @returns {JSX.Element} A tel input field
 *
 * @example
 * <PhoneNumberField />
 */

function PhoneNumberField({ phoneNumber, setPhoneNumber }) {
    const formatPhoneNumber = (e) => {
        let digits = e.target.value.replace(/\D/g, "");

        if (digits.length <= 3) {
            return digits;
        } else if (digits.length <= 6) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        } else {
            return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
        }
    };

    const handleChange = (e) => {
        setPhoneNumber(formatPhoneNumber(e));
    };

    return (
        <div className="phone-number-field">
            <label htmlFor="phone" className="phone-number-field__label">
                Phone
            </label>
            <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="(XXX) XXX-XXXX"
                value={phoneNumber}
                onChange={handleChange}
                maxLength={14}
                required
            />
        </div>
    );
}

export default PhoneNumberField;
